<template>
  <div class="tlive-create__cover" @click="setCover">
    <yxt-image :src="value" fit="cover" />
    <div class="tlive-create__cover--text">
      {{ $t('pc_biz_setCover' /* 设置封面 */) }}
    </div>
    <yxtbiz-image-cropper
        module-name="tlive"
        function-name="tlive"
        app-code="tlive"
        :size="10240"
        rate="16:9"
        :suggest="{ w: 640, h: 360 }"
        :src="value"
        :visible.sync="showCropper"
        @complete="complete"
    ></yxtbiz-image-cropper>
  </div>
</template>
<script>
export default {
  name: 'LiveCover',
  props: {
    value: {
      type: String,
      default: function() {
        return `${this.$staticBaseUrl}0f43ff1b/c8ea2516/bgCover.svg`;
      }
    }
  },
  data() {
    return {
      showCropper: false,
      url: ''
    };
  },
  methods: {
    setCover() {
      this.showCropper = true;
    },
    complete(src) {
      if (src) {
        this.$emit('input', src);
      }
    }
  }
};
</script>
<style scoped lang="less"></style>
